import {WixSdk} from 'js-sdk-wrapper';
import {noop} from '../utils/functions';
import {getWixParams} from './send-event';
import {subscribeToEmitter} from './subscribe-to-emitter';

export function reportBiError(errorDescription, {reason, ...errorParams}: any = {}) {
  const {visitorId, biToken, instanceId} = getWixParams();
  const params = {
    ...errorParams,
    src: 9,
    evid: 10,
    cat: 1,
    iss: 1,
    errc: errorDescription.id,
    errn: errorDescription.name,
    sev: errorDescription.severity,
    app_id: instanceId, // eslint-disable-line camelcase
    msid: biToken,
    cid: visitorId
  };
  sendEvents('trg', params);
}

function sendEvents(adapter, params) {
  params = {
    _: Number(new Date()),
    ...params
  };
  const paramsStr = Object.keys(params)
    .filter(key => {
      return params[key] !== undefined;
    })
    .map(key => {
      const value = encodeURIComponent(params[key]);
      return `${key}=${value}`;
    })
    .join('&');

  const url = `//frog.wix.com/${adapter}?${paramsStr}`;
  const img = new Image();
  // IF core js was not loaded
  const PromisePolyfilled = typeof Promise === 'undefined' ? PromiseStub : Promise;
  return new PromisePolyfilled((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
    img.src = url;
  });
}

let playerStartedFired = false;
export function logToBi(statisticsEvents, {isOwner, biToken, instanceId, compId, visitorId}) {
  const events = {
    playerStarted: {
      id: 189,
      name: 'player.pageOpened',
      params({album, loading_time}) {
        return {albumID: album.id, loading_time};
      }
    },
    trackPlayStart: {
      id: 190,
      name: 'player.track.played',
      params: baseTrackData
    },
    trackSkipped: {
      id: 191,
      name: 'player.track.skipped',
      params: baseTrackData
    },
    trackPlayCompleted: {
      id: 192,
      name: 'player.track.completed',
      params: baseTrackData
    },
    trackPurchaseClicked: {
      id: 194,
      name: 'player.track.purchase.clicked',
      params: args => ({
        ...baseTrackData(args),
        price: (args.track.trackPrice * 10000).toFixed(0),
        currency: args.album.currency
      })
    },
    trackShareClicked: {
      id: 202,
      name: 'player.track.shared',
      params: args => ({
        ...baseTrackData(args),
        socialNetwork: args.network
      })
    },
    albumPlayCompleted: {
      id: 196,
      name: 'player.album.playComplete',
      params: baseAlbumData
    },
    albumPurchaseClicked: {
      id: 198,
      name: 'player.album.purchase.clicked',
      params: args => ({
        ...baseAlbumData(args),
        price: (args.album.albumPrice * 10000).toFixed(0),
        currency: args.album.currency
      })
    },
    albumShareClicked: {
      id: 200,
      name: 'player.album.shared',
      params: args => ({
        ...baseAlbumData(args),
        socialNetwork: args.network
      })
    },
    playerAudioFailed: {
      id: 205,
      name: 'player.audio.failed',
      params: baseTrackData
    },
    trackPlayAttempt: {
      id: 207,
      name: 'player.track.play.attempt',
      params: baseTrackData
    },
    viewTrackPage: {
      id: 208,
      name: 'player.track.viewTrackPage.clicked',
      params: args => ({
        ...baseTrackData(args),
        isOwner
      })
    }
  };

  subscribeToEmitter(statisticsEvents, events, send);

  function send(eventName, eventDescription, eventArgs) {
    const viewMode = WixSdk.Utils.getViewMode();
    const isFirstPlayerStartEvent = eventName === 'playerStarted' && !playerStartedFired;
    if (!isFirstPlayerStartEvent && (viewMode === 'editor' || viewMode === 'preview')) {
      return;
    }
    if (isFirstPlayerStartEvent) {
      playerStartedFired = true;
    }

    const params = {
      src: 9,
      evid: eventDescription.id,
      visitorId,
      sid: biToken,
      playerInstanceID: instanceId,
      compId,
      isOwner,
      ...(eventDescription.params || noop)(eventArgs)
    };
    sendEvents('music-ugc', params);
  }

  function baseAlbumData({album}) {
    return {
      albumID: album.id
    };
  }

  function baseTrackData({album, track}) {
    return {
      ...baseAlbumData({album}),
      trackID: track.id,
      trackIdxInAlbum: album.tracks.indexOf(track)
    };
  }
}

export function sendPlayerStartedEvent() {
  const {
    compId,
    visitorId,
    instanceId,
    biToken,
    isOwner
  } = getWixParams();

  const params = {
    src: 9,
    evid: 189,
    visitorId,
    sid: biToken,
    playerInstanceID: instanceId,
    compId,
    isOwner,
    albumID: WMP.wixUtils.getRandomGuid4(),
    loading_time: window.performance && window.performance.now ? window.performance.now() : null
  };
  sendEvents('music-ugc', params);

}
class PromiseStub {
  constructor(resolver) {
    resolver(() => {
    }, () => {
    });
  }
}



// WEBPACK FOOTER //
// ./statistics/bi.ts